import React, { useState } from 'react';
import { CahierJournalView } from '../types';
import { UserLocale } from '@teetsh/app/src/types/user';
import { useCJConfigurationDisplay } from '@teetsh/app/src/containers/CahierJournal/useCJConfigurationDisplay';
import { useFieldsToDisplay } from '../Toolbar/Filters/FieldsToDisplay/atom';
import { format } from '@teetsh/app/src/utils/time/format';
import { isoDatePatternWithSlashes } from '@teetsh/app/src/utils/time/datePatterns';
import { useCollapsedDays } from '../atoms';
import {
  buildCJPDFParams,
  isLandscape,
} from 'containers/CahierJournal/Preview/Sidebar/buildCJPDFParams';
import { useFormState } from 'react-final-form';
import { useSendUpdateParamsToIframe } from 'components/Iframe/useSendUpdateParamsToIframe';
import { CJPDFSettings } from 'types/cj';
import { IframePreviewPDF } from 'components/Print/IframePreviewPDF';

interface Props {
  schoolyearId: string;
  schoolId: string;
  view: CahierJournalView | 'days';
  date: Date;
  lng: UserLocale;
  tz: string;
}

export function Body(props: Props) {
  const { schoolyearId, schoolId, view, date, lng, tz } = props;
  const { values } = useFormState<CJPDFSettings>();

  const { classroomsId, hideEvents } = useCJConfigurationDisplay();
  const fieldsToDisplay = useFieldsToDisplay();
  const collapsedDays = useCollapsedDays();

  const url = new URL(
    `/print/annee-scolaire/${schoolyearId}/ecole/${schoolId}/cahier-journal/${view}/${format(
      date,
      'fr-FR',
      isoDatePatternWithSlashes,
    )}`,
    window.location.origin,
  );
  url.search = buildCJPDFParams({
    lng,
    tz,
    classroomsId,
    collapsedDays,
    fieldsToDisplay,
    hideEvents,
    settings: values,
    view,
  }).toString();

  const [urlAsString] = useState(url.toString());

  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: buildCJPDFParams({
      lng,
      tz,
      classroomsId,
      collapsedDays,
      fieldsToDisplay,
      hideEvents,
      settings: values,
      view,
    }),
  });

  return (
    <IframePreviewPDF
      landscape={isLandscape(
        values.landscape || false,
        view,
        values.direction || 'next',
      )}
      iframeUrl={urlAsString}
      iframeRef={iframeRef}
    />
  );
}
